import * as msal from '@azure/msal-browser';
import jwt_decode from 'jwt-decode';

export default class AuthService {
	constructor() {
		let msalConfig = JSON.parse(localStorage.msalConfig);

    if (!AuthService.app) {
      AuthService.app = new msal.PublicClientApplication(msalConfig);
    }

		this.loginRequest = JSON.parse(localStorage.loginRequest);
		try {
			this.loginRequest.scopes.push("offline_access");
			this.loginRequest.scopes.push("email");
		} catch (e) {
			console.log(e);
		}
		this.tokenRequest = JSON.parse(localStorage.tokenRequest);
		this.forgotPasswordRequest = JSON.parse(localStorage.forgotPasswordRequest);
	}

	login() {
		localStorage.setItem("redirectInProgress", "true");
		AuthService.app.loginRedirect(this.loginRequest);
	}

	refresh() {
		return new Promise((resolve, reject) => {
			let tmpRequest = Object.assign({}, this.loginRequest);
			try {
				let tmpDecoded = jwt_decode(localStorage.customToken);
				let tmpAccount = Object.assign({}, AuthService.app.getAllAccounts()[0]);
				tmpAccount.name = tmpDecoded.email;
				tmpAccount.username = tmpDecoded.email;

        AuthService.app.setActiveAccount(tmpAccount);
        tmpRequest.loginHint = tmpAccount.username;
        tmpRequest.sid = tmpAccount.username;
        tmpRequest.account = tmpAccount;
      } catch (e) {
        console.log('Cannot set SSO data for refresh token');
      }

      AuthService.app
        .acquireTokenSilent(tmpRequest)
        .then((res) => {
          // console.log(res);
          resolve(res);
        })
        .catch((error) => {
          console.log(error);

				try {
					AuthService.app.acquireTokenRedirect(this.loginRequest);
					localStorage.setItem("redirectInProgress", "true");
					resolve({});
				} catch (e) {
					reject(e);
				}
			});
		})
	}

  forgotPassword() {
    AuthService.app.loginRedirect(this.forgotPasswordRequest);
  }

  logout() {
    return new Promise((resolve) => {
      AuthService.app.logout();
      resolve();
    });
  }

  isLogIn() {
    const currentAccounts = AuthService.app.getAllAccounts();
    return currentAccounts && currentAccounts.length > 0;
  }
}